/*!
 * Copyright 2018, Selerix Systems, Inc. All Rights Reserved
 * This is unpublished proprietary source code of Selerix, Inc. The
 * copyright notice above does not evidence any actual or intended
 * publication of such source code.
 */

// override for auto complete search
(function (a) {
    if (a.jqx._jqxSlider.prototype._addTick === void 0) {
		a.jqx._jqxSlider.prototype._addTick = function (b, i, n, p, c, j, o) {
			var q = "";
			q = this.toThemeProperty("jqx-slider-tick");
			q += " " + this.toThemeProperty("jqx-fill-state-pressed");
			if (this.template) {
				q += " " + this.toThemeProperty("jqx-" + this.template)
			}
			var e;
			var l = this._getSetting("top");
			var d = "2px";
			var f = this.tickSize;
			if (o) {
				f = this.minorTickSize
			}
			if (b[0] !== this._topTicks[0]) {
				d = p - f - 2 + "px"
			}
			var w = this._track.width();
			if (this.orientation === "horizontal") {
				i = i / w * 100;
				e = '<div style="' + l + ": " + d + "; " + this._getSetting("oSize") + ":  " + f + "px; float: left; position:absolute; left:" + i + '%;" class="' + this.toThemeProperty("jqx-slider-tick-horizontal") + " " + q + '"></div>';
				if (this.showTickLabels) {
					if (b[0] !== this._topTicks[0]) {
						d = p - f - j.height - 2 + "px"
					} else {
						d = 2 + f + "px"
					}
					var m = j.width * c.toString().length;
					m = m / 2;
					var k = i - m;
					e += '<div style="' + l + ": " + d + "; float: left; position:absolute; left:" + k + 'px;">' + c + "</div>"
				}
			} else {
				e = '<div style="' + l + ": " + d + "; " + this._getSetting("oSize") + ":  " + f + "px; float: none; position:absolute; top:" + i + 'px;" class="' + this.toThemeProperty("jqx-slider-tick-vertical") + " " + q + '"></div>';
				if (this.showTickLabels) {
					if (b[0] !== this._topTicks[0]) {
						d = p - f - c.toString().length * j.width - 6 + "px"
					} else {
						d = 6 + f + "px"
					}
					var g = j.height;
					g = g / 2;
					var k = i - g;
					e += '<div style="' + l + ": " + d + "; float: none; position:absolute; top:" + k + 'px;">' + c + "</div>"
				}
			}
			return e
		};
		a.jqx._jqxSlider.prototype._refreshRangeBar = function () {
			var e = this._getSetting("left");
			var c = this._getSetting("size");
			var d = this.rtl && this.orientation == "horizontal";

			var positive = this._slider.right.position()[e] > this._slider.left.position()[e];

			if (this.layout == "normal") {
				var b = positive ? this._slider.left.position()[e] : this._slider.right.position()[e];
				if (this.orientation === "vertical" || d) {
					b = positive ? this._slider.right.position()[e] : this._slider.left.position()[e];
				}
			} else {
				var b = (positive) ? this._slider.right.position()[e] : this._slider.left.position()[e];
				if (this.orientation === "vertical" || d) {
					var b = (positive) ? this._slider.left.position()[e] : this._slider.right.position()[e];
				}
			}

			this._rangeBar.css(e, b + this._slider.left[c]() / 2);
			var size = positive ?
				Math.abs(this._slider.right.position()[e] - this._slider.left.position()[e]) :
				Math.abs(this._slider.left.position()[e] - this._slider.right.position()[e])
			this._rangeBar[c](size);
		};
		a.jqx._jqxSlider.prototype._validateValue = function (c, b) {
			if (this.int64 === false) {
				if (c > this.max) {
					c = this.max
				}
				if (c < this.min) {
					c = this.min
				}
				//if (this.rangeSlider) {
				//	if (b[0] === this._slider.left[0]) {
				//		if (c >= this.values[1]) {
				//			c = this.values[1]
				//		}
				//	} else {
				//		if (c <= this.values[0]) {
				//			c = this.values[0]
				//		}
				//	}
				//}
			} else {
				if (this.int64 === "s") {
					if (c.greaterThan(this._max64)) {
						c = this._max64
					}
					if (c.lessThan(this._min64)) {
						c = this._min64
					}
				} else {
					if (this.int64 === "u") {
						if (c.compare(this._max64) === 1) {
							c = this._max64
						}
						if (c.compare(this._min64) === -1) {
							c = this._min64
						}
					}
				}
			}
			return c
		};
	}
})(jqxBaseFramework);

$.jqx._jqxChart.prototype.colorSchemes.push({ name: 'selerix', colors: ['#2780e3', '#9954bb', '#ff7518', '#1f9607', '#ee1010'] });
$.jqx._jqxChart.prototype.colorSchemes.push({ name: 'grayscale', colors: ['#555555', '#cccccc', '#777777', '#aaaaaa', '#333333'] });
$.jqx._jqxChart.prototype.colorSchemes.push({ name: 'everwell', colors: ['#00b0b9', '#00c8d2', '#ffcd00', '#000', '#bebebe'] });

var SliderChart = function (containerSelector, width, height) {
	var self = this;
	self._visibilityCheck = null;
	self._initialized = false;
	self._settings = {
		title: "",
		description: "",
		enableAnimations: true,
		enableAxisTextAnimation: true,
		animationDuration: 200,
		borderLineWidth: 0,
		showLegend: true,
		padding: { top: 5, right: 5, bottom: 5, left: 5 },
		titlePadding: { top: 10, right: 0, bottom: 10, left: 0 },
		source: null,
		columnSeriesOverlap: false,
		xAxis: {
			dataField: 'Coverage',
			unitInterval: 1,
			axisSize: 'auto',
			tickMarks: {
				visible: true,
				interval: 1,
				color: '#f0f0f0'
			},
			gridLines: {
				visible: true,
				interval: 1,
				color: '#f0f0f0'
			},
			valuesOnTicks: false
		},
		valueAxis: {
			unitInterval: 2500,
			//customDraw: true,
			visible: true,
			baselineValue: 1,
			baselineColor: '#666666',
			//title: { text: 'Cost in dollars' },
			labels: { horizontalAlignment: 'right' },
			tickMarks: { color: '#f0f0f0' },
			gridLines: { color: '#f0f0f0' },
			formatFunction: function (value) { return value.formatAs('money', 0); }
		},
		colorScheme: 'scheme01',
		seriesGroups: [{
			type: 'stackedcolumn',
			columnsGapPercent: 25,
			seriesGapPercent: 5,
			columnsMaxWidth: 50,
			columnsMinWidth: 5,
			useGradient: false,
			skipOverlappingPoints: false,
			toolTipFormatFunction: function (value, itemIndex, serie, group, xAxisValue, xAxis) {
			    var item = self.items !== null ? $.grep(self.items, function (a) { return a.Name == xAxisValue; }) : [];
				var i = (item.length) ? item[0] : null;
				return xAxisValue + " " + (i ? " <small>(" + i.Tier + ")</small>" : "") +
					"<br/><h4>" + serie.displayText + ": <span class='text-success'>" + value.formatAs("money") + "</span></h4>";
			},
			toolTipFormatSettings: { padding: '15px' },
            toolTipHideDelay: 0,
			toolTipBackground: '#222222',
			toolTipLineColor: '#222222',
			toolTipClass: 'jqx-chart-tooltip',
			series: [
				//{ dataField: 'ProjectedInsurance', displayText: 'Insurance', fillColor: '#333333', lineColor: '#ffffff', lineWidth: 1 }
			]
		}]
	};
	self.selector = containerSelector;
	self.container = null;
	self.aspectRatio = null;
	self.instance = null;
	self.renderer = null;
	self.size = { width: width, height: height };
	self.dataAdapter = null;
	self.groupDataField = 'Name';
	self.drawCallback = null;
	self.items = null;
	self.showEmployer = false;
	self.error = null;
	self.labels = {
		ProjectedCost: 'You',
		ProjectedEmployer: 'Employer',
		ProjectedInsurance: 'Insurance'
	};
};
SliderChart.prototype.init = function (callBack) {
	// update settings
	if (this.groupDataField) this._settings.xAxis.dataField = this.groupDataField;

	var you = $.grep(this._settings.seriesGroups[0].series, function (r) { return r.dataField === 'ProjectedCost' });
	if (you.length === 0) {
		this._settings.seriesGroups[0].series.push({ dataField: 'ProjectedCost', displayText: this.labels.ProjectedCost, fillColor: '#1f9607', lineColor: '#ffffff', lineWidth: 1 });
	}

	if (this.showEmployer) {
		var empr = $.grep(this._settings.seriesGroups[0].series, function (r) { return r.dataField === 'ProjectedEmployer' });
		if (empr.length === 0) {
			this._settings.seriesGroups[0].series.push({ dataField: 'ProjectedEmployer', displayText: this.labels.ProjectedEmployer, fillColor: '#9954bb', lineColor: '#ffffff', lineWidth: 1 });
		}
	}
	// get container
	this.container = $(this.selector);
	this.container.width(this.size.width || 1200);
	this.container.height(this.size.height || 1200);
	if (!this.container.hasClass("responsive-chart")) this.container.addClass("responsive-chart");
	if (this.container.length) this.container[0].sliderChart = this;

	// draw chart
	if (this.container.is(":visible")) {
		this._initialized = true;
		this.draw(callBack);
	} else {
		this._visibilityCheck = setInterval(function (self) {
			if (!self.container.is(":visible")) return;
			clearInterval(self._visibilityCheck);
			self._initialized = true;
			self._visibilityCheck = null;
			self.draw(callBack);
		}, 100, this);
		this.error = "Error: Chart not visible.";
	}
};
SliderChart.prototype.draw = function (callBack) {
	if (typeof (callBack) === 'function') this.drawCallback = callBack;
	if (!this._initialized) { this.init(callBack); return; }
	if (this.items && this.items.length) {
		this.dataAdapter = new $.jqx.dataAdapter({ localData: this.items, dataType: 'array' }, { autoBind: true });
		this._settings.source = this.dataAdapter;
	}
	this.container.jqxChart(this._settings);
	this.instance = this.container.jqxChart('getInstance');
	this.renderer = this.instance.renderer;

	var self = this;

	var idx = this.container.find('g > g:not([clip-path]) ~ text').length, nans = 0;
	this.container.find('g > g:not([clip-path]) ~ text').each(function (index) {
		var val = parseInt($(this).text().replace('$', '').replaceAll(',', ''));
		if (isNaN(val) || val < 0) nans++;
	});
	idx -= nans;
	var baseline = self.container.find('g > g:not([clip-path]) ~ line:eq(' + idx + ')');
	baseline.attr('stroke', '#999999').attr('stroke-width', 3);

	if (typeof (this.drawCallback) === 'function') this.drawCallback();
};
SliderChart.prototype.update = function (arr, callBack) {
	if (this.instance === void 0 || this.instance === null) return;
	if (arr === null || arr === void 0) arr = this.items;
	this.dataAdapter = new $.jqx.dataAdapter({ localData: arr, dataType: 'array' }, { autoBind: true });
	this.instance.source = this.dataAdapter;
	this.instance.update();

	var idx = this.container.find('svg > g[clip-path] ~ text').length, nans = 0;
	this.container.find('svg > g[clip-path] ~ text').each(function (index) {
		var val = parseInt($(this).text().replace('$', '').replaceAll(',', ''));
		if (isNaN(val) || val < 0) nans++;
	});
	idx -= nans;

	var baseline = this.container.find('svg > g[clip-path] > g ~ line:eq(' + idx + ')');
	baseline.attr('stroke', '#999999').attr('stroke-width', 3);

	if (typeof (callBack) === 'function') callBack();
};